<template>
  <div class="ai-advisor-wrapper mx-auto">
    <div class="chat-header">
      <v-btn icon @click="$router.go(-1)" class="back-btn">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div class="header-title">
        <h3>AI 투자비서 펀투비</h3>
        <p class="subtitle">현명한 투자를 도와드립니다</p>
      </div>
    </div>

    <div class="chat-container" ref="chatContainer">
      <div class="chat-messages">
        <div
          v-for="(message, index) in messages"
          :key="index"
          :class="['message', message.type]"
        >
          <div class="message-content">
            <div v-if="message.type === 'ai'" class="ai-avatar">
              <v-icon color="#1baaf1">mdi-robot</v-icon>
            </div>
            <div class="message-bubble">
              <div v-if="message.type === 'ai'" class="ai-name">펀투비</div>
                             <div class="message-text" v-html="message.text"></div>

               <!-- 선택지가 있는 경우 -->
                             <div v-if="message.options" class="message-options">
                 <!-- 투자 성향 선택지 -->
                 <div class="preference-options">
                   <div
                     v-for="(option, optionIndex) in message.options.filter(opt => !opt.isCompleteButton)"
                     :key="optionIndex"
                     class="option-item preference-item"
                     :class="{ selected: option.selected }"
                     @click="selectOption(option, index)"
                   >
                     <div class="option-content">
                       <div class="checkbox">
                         <v-icon v-if="option.selected" color="#1baaf1" size="20">mdi-check-circle</v-icon>
                         <v-icon v-else color="#ccc" size="20">mdi-checkbox-blank-circle-outline</v-icon>
                       </div>
                       <span class="option-text">{{ option.text }}</span>
                     </div>
                   </div>
                 </div>

                 <!-- 선택 완료 버튼 -->
                 <div class="complete-button-wrapper">
                   <div
                     v-for="(option, optionIndex) in message.options.filter(opt => opt.isCompleteButton)"
                     :key="optionIndex"
                     class="option-item complete-button"
                     :class="{ disabled: option.disabled }"
                     @click="option.disabled ? null : selectOption(option, index)"
                   >
                     {{ option.text }}
                   </div>
                 </div>
               </div>

              <!-- 투자 상품 추천 목록 -->
              <div v-if="message.recommendations" class="recommendations">
                <div
                  v-for="(rec, recIndex) in message.recommendations"
                  :key="recIndex"
                  class="recommendation-item"
                >
                  <div class="rec-header">
                    <v-checkbox
                      v-model="rec.selected"
                      color="#1baaf1"
                      @change="updateSelectedRecommendations"
                    ></v-checkbox>
                    <span class="rec-title">{{ rec.title }}</span>
                  </div>
                  <div class="rec-details">
                    <p class="rec-loan">{{ rec.loanInfo }}</p>
                    <p class="rec-sales">월평균 매출액 {{ rec.monthlySales }}</p>
                    <p class="rec-features">
                      <span v-for="(feature, featureIndex) in rec.features" :key="featureIndex" class="feature-tag">
                        {{ feature }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <!-- 투자 금액 입력 -->
              <div v-if="message.showAmountInput" class="amount-input">
                <v-text-field
                  v-model="investmentAmount"
                  label="투자 금액 (원)"
                  type="number"
                  outlined
                  dense
                  @keyup.enter="confirmAmount"
                ></v-text-field>
                <v-btn color="#1baaf1" @click="confirmAmount" class="confirm-btn">
                  투자금액 결정
                </v-btn>
              </div>

                             <!-- 분산 투자 방식 선택 -->
               <div v-if="message.showDistributionOptions" class="distribution-options">
                 <div
                   v-for="(option, optionIndex) in message.distributionOptions"
                   :key="optionIndex"
                   class="distribution-option"
                   @click="selectDistribution(option)"
                 >
                   {{ option.text }}
                 </div>
               </div>

               <!-- 투자 결과 표시 -->
               <div v-if="message.investmentResults" class="investment-results">
                 <div class="results-header">
                   <h4>투자 계획</h4>
                   <p>총 투자금액: {{ $options.filters.commaFormat(investmentAmount) }}원</p>
                 </div>
                 <div class="results-list">
                   <div
                     v-for="(result, resultIndex) in message.investmentResults"
                     :key="resultIndex"
                     class="result-item"
                   >
                     <span class="result-title">{{ result.title }}</span>
                     <span class="result-amount">{{ $options.filters.commaFormat(result.amount) }}원</span>
                   </div>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </div>
         </div>
   </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { AuthTypes } from '@/store/types/auth'
import { InvestmentTypes } from '@/store/types/investment'
import { TimeTypes } from '@/store/types/time'

export default {
  name: 'AIInvestmentAdvisor',
  data() {
    return {
      messages: [],
      currentStep: 0,
      userPreferences: {
        marketing: false,
        highSales: false,
        goodRepayment: false
      },
      selectedRecommendations: [],
      investmentAmount: '',
      distributionMethod: '',
      fundingsLoading: false,
      rawData: [],
      paging: {
        offset: 0,
        size: 50
      }
    }
  },
  computed: {
    ...mapGetters('auth', {
      isAuthenticated: AuthTypes.getters.IS_AUTHENTICATED,
      profile: AuthTypes.getters.GET_PROFILE,
      balance: AuthTypes.getters.GET_BALANCE,
    }),
    ...mapState('funding', {
      storeInvestFundings: 'investFundings',
      investFundingsRawDatas: 'investFundingsRawDatas'
    }),
    userName() {
      return this.profile?.name || '투자자'
    },
    availableBalance() {
      console.log('Balance data:', this.balance)
      console.log('Balance type:', typeof this.balance)
      console.log('Balance keys:', this.balance ? Object.keys(this.balance) : 'null')
      const balance = this.balance?.withdraw || 0
      console.log('Available balance:', balance)
      return balance
    },
    // balance가 로드되었는지 확인
    isBalanceLoaded() {
      return this.balance !== null && this.balance !== undefined
    },
    // 실제 투자 상품 데이터를 카테고리별로 분류
    categorizedFundings() {
      if (!this.rawData || this.rawData.length === 0) return []

      return this.rawData.map(funding => {
        // 랜덤 특징 배정 (실제 데이터에는 없는 정보이므로 임시로 생성)
        const features = this.generateRandomFeatures(funding)
        const category = this.determineCategory(features)

        return {
          id: funding.fundingDataIdx,
          title: funding.title,
          loanInfo: `대출신청액 ${this.$options.filters.commaFormat(funding.announcedAmount)}원 (연 ${funding.interestRate}%, ${funding.loanPeriod}개월 원리금 일상환)`,
          monthlySales: this.formatMonthlySales(funding.averageMonthlySales || funding.forecastedMonthlySales),
          features: features,
          category: category,
          funding: funding // 원본 데이터 보존
        }
      })
    }
  },
  async mounted() {
    // balance가 로드되지 않았다면 가져오기
    if (this.isAuthenticated && (!this.balance || !this.balance.withdraw)) {
      console.log('Balance not loaded, fetching...')
      await this.getBalance()
    }
    await this.getInvestingFundings()
    this.startConversation()
  },
  methods: {
    ...mapActions('auth', {
      getBalance: AuthTypes.actions.GET_BALANCE,
    }),
    ...mapActions('investment', {
      getUserP2p: InvestmentTypes.actions.GET_USER_P2P,
    }),
    ...mapActions('time', {
      getIsInspectTime: TimeTypes.actions.GET_CANNOT_INVEST_TIME,
    }),

    // 랜덤 특징 생성
    generateRandomFeatures(funding) {
      const features = []
      const random = Math.random()

      // AI 마케팅 특징 (30% 확률)
      if (random < 0.3) {
        features.push('AI단골관리 활용 상점')
      }

      // 매출 우수 특징 (40% 확률)
      if (random < 0.4) {
        features.push('매출우수')
      }

      // 상환 이력 우수 특징 (25% 확률)
      if (random < 0.25) {
        const repaymentCount = Math.floor(Math.random() * 20) + 5
        features.push('상환이력우수', `총 ${repaymentCount}회 정상 상환`)
      }

      // 특징이 없으면 기본 특징 추가
      if (features.length === 0) {
        features.push('안정적인 상점')
      }

      return features
    },

    // 카테고리 결정
    determineCategory(features) {
      if (features.some(f => f.includes('AI단골관리'))) {
        return 'marketing'
      } else if (features.some(f => f.includes('매출우수'))) {
        return 'highSales'
      } else if (features.some(f => f.includes('상환이력우수'))) {
        return 'goodRepayment'
      } else {
        // 기본값은 랜덤 배정
        const categories = ['marketing', 'highSales', 'goodRepayment']
        return categories[Math.floor(Math.random() * categories.length)]
      }
    },

    // 월 매출액 포맷팅
    formatMonthlySales(sales) {
      if (!sales) return '정보없음'
      const salesNum = parseInt(sales)
      if (salesNum >= 10000) {
        return `${Math.floor(salesNum / 10000)}천만원`
      } else {
        return `${salesNum}만원`
      }
    },

    // 투자 상품 데이터 가져오기
    async getInvestingFundings() {
      if (this.fundingsLoading) return

      this.fundingsLoading = true
      this.paging.offset = 0

      try {
        await this.fetchData()
      } finally {
        this.fundingsLoading = false
      }
    },

    async fetchData() {
      const q = `
        data: getInvestFundingDatas(inputInvestFundingDatas: {
          offset: ${this.paging.offset}
          size: ${this.paging.size}
          type: ""
        }) {
          fundingDataIdx
          title
          subTitle
          visible
          totalAmount
          announcedAmount
          interestRate
          loanPeriod
          disclosureDate
          investmentStartDate
          investmentClosureDate
          minInvestAmount
          maxInvestAmount
          unitInvestAmount
          status
          useDays
          currentInvestmentAmount
          alreadyInvested
          averageMonthlySales
          forecastedMonthlySales
          fundanowType
          isOpen
          fnStore {
            storeName
            jangsaHelperYn
            storeType1
            storeType2
          }
        }
      `

      try {
        const [response] = await Promise.all([
          this.$fundaApi.query(gql`{${q}}`),
          this.getUserP2p()
        ])
        const data = response || []
        this.rawData = data.filter(funding => funding.isOpen === true)
      } catch (e) {
        console.error('투자 상품 조회 중 오류가 발생했습니다:', e)
        // 에러 발생 시 빈 배열로 초기화
        this.rawData = []
      }
    },

    async startConversation() {
      // 초기 인사말
      await this.addAIMessage(`안녕하세요, ${this.userName} 투자자님.<br>AI 투자비서 펀투비입니다.`)

      await this.delay(1000)

      await this.addAIMessage(`${this.userName} 님의 투자 성향을 간단히 파악한 후에 편리한 투자를 안내해 드리겠습니다.`)

      await this.delay(1000)

      // 투자 성향 선택
      await this.addAIMessage('일단 아래 선택지 중에서 선호하시는 투자 대상을 중복 체크해 주세요 (모두 체크하셔도 괜찮습니다)', {
        options: this.getPreferenceOptions()
      })
    },

    async selectOption(option, messageIndex) {
      // 사용자 선택 메시지 추가
      this.addUserMessage(option.text)

      // 선택에 따른 처리
      switch (option.action) {
        case 'selectMarketing':
          this.userPreferences.marketing = !this.userPreferences.marketing
          break
        case 'selectHighSales':
          this.userPreferences.highSales = !this.userPreferences.highSales
          break
        case 'selectGoodRepayment':
          this.userPreferences.goodRepayment = !this.userPreferences.goodRepayment
          break
        case 'completePreferences':
          // 해당 메시지의 선택지 제거
          this.messages[messageIndex].options = null
          await this.showRecommendations()
          return
        case 'confirmAmount':
          await this.confirmInvestmentAmount()
          return
        case 'proceedInvestment':
          await this.proceedToInvestment()
          return
        case 'executeInvestment':
          await this.executeInvestment()
          return
        case 'restart':
          await this.restartConversation()
          return
        case 'goBackToInvest':
          // AI 투자 결과가 저장된 상태로 투자 페이지로 이동
          this.$router.push({ name: 'invest' })
          return
      }

      // 선택 상태가 변경된 경우 선택된 항목들을 표시
      if (['selectMarketing', 'selectHighSales', 'selectGoodRepayment'].includes(option.action)) {
        await this.delay(500)
        await this.updateSelectionDisplay()
      }
    },

    async updateSelectionDisplay() {
      const selectedItems = []
      if (this.userPreferences.marketing) selectedItems.push('마케팅 잘하는 상점')
      if (this.userPreferences.highSales) selectedItems.push('매출이 높은 상점')
      if (this.userPreferences.goodRepayment) selectedItems.push('대출 상환 이력이 우수한 상점')

      if (selectedItems.length > 0) {
        await this.addAIMessage(`선택하신 항목: ${selectedItems.join(', ')}<br><br>추가로 선택하시거나 "선택 완료"를 클릭해주세요.`, {
          options: this.getPreferenceOptions()
        })
      } else {
        await this.addAIMessage('선택된 항목이 없습니다. 다시 선택해주세요.', {
          options: this.getPreferenceOptions()
        })
      }
    },

    getPreferenceOptions() {
      return [
        {
          text: '1. 마케팅 잘하는 상점',
          action: 'selectMarketing',
          selected: this.userPreferences.marketing
        },
        {
          text: '2. 매출이 높은 상점',
          action: 'selectHighSales',
          selected: this.userPreferences.highSales
        },
        {
          text: '3. 대출 상환 이력이 우수한 상점',
          action: 'selectGoodRepayment',
          selected: this.userPreferences.goodRepayment
        },
        {
          text: '선택 완료',
          action: 'completePreferences',
          disabled: !this.userPreferences.marketing && !this.userPreferences.highSales && !this.userPreferences.goodRepayment,
          isCompleteButton: true
        }
      ]
    },

    async showRecommendations() {
      await this.delay(500)

      // 선택된 카테고리에 따른 추천 상품 필터링
      const selectedCategories = []
      if (this.userPreferences.marketing) selectedCategories.push('marketing')
      if (this.userPreferences.highSales) selectedCategories.push('highSales')
      if (this.userPreferences.goodRepayment) selectedCategories.push('goodRepayment')

      const recommendations = this.categorizedFundings.filter(funding =>
        selectedCategories.includes(funding.category)
      ).slice(0, 10)

      // 추천 상품들을 기본으로 모두 선택되도록 설정
      recommendations.forEach(rec => {
        rec.selected = true
      })

      await this.addAIMessage(`현명한 선택이십니다! 지금 투자 가능한 상점들 중에서 ${this.userName}님의 투자 성향에 맞는 투자 상품들을 <strong>${recommendations.length}개</strong> 추천해 드릴께요.`, {
        recommendations: recommendations
      })

      // 상점 목록 아래에 투자 진행 버튼 추가
      await this.addAIMessage('', {
        options: [
          { text: `체크한 ${recommendations.length}개의 상점들에 투자 진행`, action: 'proceedInvestment' }
        ]
      })

      // 추천 상품들이 기본으로 모두 선택되어 있으므로 selectedRecommendations 업데이트
      this.updateSelectedRecommendations()
    },

    updateSelectedRecommendations() {
      this.selectedRecommendations = this.messages
        .filter(msg => msg.recommendations)
        .flatMap(msg => msg.recommendations)
        .filter(rec => rec.selected)

      // 선택된 개수가 변경되면 메시지와 버튼 텍스트 업데이트
      this.updateRecommendationMessages()
    },

    updateRecommendationMessages() {
      const selectedCount = this.selectedRecommendations.length

      // 추천 상품이 있는 메시지들을 찾아서 업데이트
      this.messages.forEach(message => {
        if (message.recommendations) {
          // AI 메시지 텍스트 업데이트
          message.text = `현명한 선택이십니다! 지금 투자 가능한 상점들 중에서 ${this.userName}님의 투자 성향에 맞는 투자 상품들을 <strong>${selectedCount}개</strong> 추천해 드릴께요.`
        }

        // 투자 진행 버튼이 있는 메시지 업데이트
        if (message.options && message.options.some(opt => opt.action === 'proceedInvestment')) {
          const proceedOption = message.options.find(opt => opt.action === 'proceedInvestment')
          if (proceedOption) {
            proceedOption.text = `체크한 ${selectedCount}개의 상점들에 투자 진행`
          }
        }
      })
    },

    async proceedToInvestment() {
      if (this.selectedRecommendations.length === 0) {
        await this.addAIMessage('투자할 상점을 선택해주세요.')
        return
      }

      await this.addAIMessage(`총 ${this.selectedRecommendations.length}개 상점에 투자를 결정하셨습니다!`)

      await this.delay(1000)

      // balance 정보 확인 (store에서 읽기만)
      console.log('현재 balance 정보:', this.balance)

      await this.addAIMessage(`${this.userName}님의 현재 투자 가능 예치금은 ${this.$options.filters.commaFormat(this.availableBalance)}원입니다. 그 중 오늘 ${this.selectedRecommendations.length}개 상점에 총 얼마를 투자하실 계획인지 알려주세요.`, {
        showAmountInput: true
      })
    },

    async confirmAmount() {
      const amount = parseInt(this.investmentAmount)
      if (!amount || amount <= 0) {
        await this.addAIMessage('올바른 투자 금액을 입력해주세요.')
        return
      }

      if (amount > this.availableBalance) {
        await this.addAIMessage('투자 금액이 예치금을 초과합니다.')
        return
      }

      // 마지막 메시지의 입력 필드 제거
      const lastMessage = this.messages[this.messages.length - 1]
      lastMessage.showAmountInput = false

      await this.addUserMessage(`${this.$options.filters.commaFormat(amount)}원 투자`)

      await this.delay(1000)

      await this.addAIMessage(`${this.$options.filters.commaFormat(amount)}원 투자를 결정하셨습니다. 이제 어떻게 나누어 투자할지 결정해 주세요.`, {
        showDistributionOptions: true,
        distributionOptions: [
          { text: `1. ${this.$options.filters.commaFormat(Math.floor(parseInt(this.investmentAmount) / this.selectedRecommendations.length))}원씩 동일하게 분산 투자`, method: 'equal' },
          { text: '2. 각 상점의 매출 규모에 따라 비율대로 분산 투자', method: 'proportional' }
        ]
      })
    },

    async selectDistribution(option) {
      this.distributionMethod = option.method

      await this.addUserMessage(option.text)

      // 마지막 메시지의 분산 옵션 제거
      const lastMessage = this.messages[this.messages.length - 1]
      lastMessage.distributionOptions = null

      await this.delay(1000)

      // 투자 결과 생성
      const investmentResults = this.generateInvestmentResults()

      // 조정이 있었는지 확인
      const hasAdjustment = this.checkIfAdjustmentNeeded(investmentResults)

      let messageText = '투자 계획이 완성되었습니다!'
      if (hasAdjustment) {
        messageText += '<br><br><small style="color: #666;">투자금은 1,000원 단위만 가능하므로 일부 조정이 있었습니다</small>'
      }

      await this.addAIMessage(messageText, {
        investmentResults: investmentResults
      })

      await this.delay(1000)

      await this.addAIMessage('투자를 진행하시겠습니까?', {
        options: [
          { text: '투자하기', action: 'executeInvestment' },
          { text: '다시 시작하기', action: 'restart' }
        ]
      })
    },

    generateInvestmentResults() {
      const totalAmount = parseInt(this.investmentAmount)

      if (this.distributionMethod === 'equal') {
        // 동일 분산: 최대투자금액 고려하여 분배
        return this.distributeEquallyWithMaxLimit(totalAmount)
      } else {
        // 비율 분산: 최대투자금액 고려하여 분배
        return this.distributeProportionallyWithMaxLimit(totalAmount)
      }
    },

    // 동일 분산 시 최대투자금액 고려
    distributeEquallyWithMaxLimit(totalAmount) {
      const baseAmount = Math.floor(totalAmount / this.selectedRecommendations.length / 1000) * 1000
      const remainder = totalAmount - (baseAmount * this.selectedRecommendations.length)

      // 1단계: 기본 금액 배정
      const results = this.selectedRecommendations.map((rec, index) => {
        const extraAmount = index < remainder / 1000 ? 1000 : 0
        const calculatedAmount = baseAmount + extraAmount
        const maxAmount = this.getMaxInvestmentAmount(rec)
        const actualAmount = Math.min(calculatedAmount, maxAmount)

        return {
          id: rec.id,
          title: rec.title,
          amount: actualAmount,
          maxAmount: maxAmount,
          isOverflow: calculatedAmount > maxAmount,
          overflowAmount: Math.max(0, calculatedAmount - maxAmount)
        }
      })

      // 2단계: 넘친 금액을 다른 상점들에 재분배
      return this.redistributeOverflowAmount(results, totalAmount)
    },

    // 비율 분산 시 최대투자금액 고려
    distributeProportionallyWithMaxLimit(totalAmount) {
      const totalSales = this.selectedRecommendations.reduce((sum, rec) => {
        const sales = this.parseMonthlySales(rec.monthlySales)
        return sum + sales
      }, 0)

      // 1단계: 비율에 따라 계산하고 1000원 단위로 반올림
      const results = this.selectedRecommendations.map(rec => {
        const sales = this.parseMonthlySales(rec.monthlySales)
        const ratio = sales / totalSales
        const calculatedAmount = totalAmount * ratio
        const roundedAmount = Math.round(calculatedAmount / 1000) * 1000
        const maxAmount = this.getMaxInvestmentAmount(rec)
        const actualAmount = Math.min(roundedAmount, maxAmount)

        return {
          id: rec.id,
          title: rec.title,
          amount: actualAmount,
          maxAmount: maxAmount,
          isOverflow: roundedAmount > maxAmount,
          overflowAmount: Math.max(0, roundedAmount - maxAmount)
        }
      })

      // 2단계: 넘친 금액을 다른 상점들에 재분배
      return this.redistributeOverflowAmount(results, totalAmount)
    },

    // 넘친 금액을 다른 상점들에 재분배
    redistributeOverflowAmount(results, totalAmount) {
      let totalOverflow = results.reduce((sum, result) => sum + result.overflowAmount, 0)

      // 넘친 금액이 있으면 재분배
      if (totalOverflow > 0) {
        // 넘치지 않은 상점들 찾기
        const availableStores = results.filter(result => !result.isOverflow && result.amount < result.maxAmount)

        if (availableStores.length > 0) {
          // 넘친 금액을 넘치지 않은 상점들에 비율에 따라 재분배
          const totalAvailableSpace = availableStores.reduce((sum, store) => sum + (store.maxAmount - store.amount), 0)

          availableStores.forEach(store => {
            const availableSpace = store.maxAmount - store.amount
            const ratio = availableSpace / totalAvailableSpace
            const additionalAmount = Math.min(
              Math.floor(totalOverflow * ratio / 1000) * 1000,
              availableSpace
            )

            store.amount += additionalAmount
            totalOverflow -= additionalAmount
          })

          // 남은 넘친 금액을 가장 큰 여유 공간을 가진 상점에 배정
          if (totalOverflow > 0) {
            const sortedBySpace = availableStores
              .filter(store => store.amount < store.maxAmount)
              .sort((a, b) => (b.maxAmount - b.amount) - (a.maxAmount - a.amount))

            if (sortedBySpace.length > 0) {
              const targetStore = sortedBySpace[0]
              const finalAmount = Math.min(totalOverflow, targetStore.maxAmount - targetStore.amount)
              targetStore.amount += finalAmount
              totalOverflow -= finalAmount
            }
          }
        }
      }

      // 최종 결과 반환 (amount만 추출)
      return results.map(item => ({
        id: item.id,
        title: item.title,
        amount: item.amount
      }))
    },

    // 상점의 최대투자금액 계산
    getMaxInvestmentAmount(recommendation) {
      const funding = recommendation.funding
      if (!funding) return 1000000 // 기본값 100만원

      const maxAmount = funding.announcedAmount - funding.currentInvestmentAmount
      return Math.max(0, maxAmount)
    },

    // 조정이 있었는지 확인하는 메서드
    checkIfAdjustmentNeeded(investmentResults) {
      const totalAmount = parseInt(this.investmentAmount)
      const count = this.selectedRecommendations.length

      if (this.distributionMethod === 'equal') {
        // 동일 분산의 경우: 원래 계산된 금액과 실제 배정된 금액 비교
        const originalPerAmount = totalAmount / count
        const hasAdjustment = originalPerAmount % 1000 !== 0
        return hasAdjustment
      } else {
        // 비율 분산의 경우: 원래 계산된 금액과 실제 배정된 금액 비교
        const totalSales = this.selectedRecommendations.reduce((sum, rec) => {
          const sales = this.parseMonthlySales(rec.monthlySales)
          return sum + sales
        }, 0)

        for (let i = 0; i < this.selectedRecommendations.length; i++) {
          const rec = this.selectedRecommendations[i]
          const sales = this.parseMonthlySales(rec.monthlySales)
          const ratio = sales / totalSales
          const originalAmount = totalAmount * ratio
          const actualAmount = investmentResults[i].amount

          // 원래 금액과 실제 금액이 다르면 조정이 있었음
          if (Math.abs(originalAmount - actualAmount) > 1) {
            return true
          }
        }
        return false
      }
    },

    // 월 매출액 파싱
    parseMonthlySales(salesText) {
      if (!salesText || salesText === '정보없음') return 1000000 // 기본값 100만원

      const match = salesText.match(/(\d+)천만원/)
      if (match) {
        return parseInt(match[1]) * 10000000 // 천만원 단위
      }

      const match2 = salesText.match(/(\d+)만원/)
      if (match2) {
        return parseInt(match2[1]) * 10000 // 만원 단위
      }

      return 1000000 // 기본값
    },

    async addAIMessage(text, options = {}) {
      this.messages.push({
        type: 'ai',
        text: text,
        timestamp: new Date(),
        ...options
      })

      await this.scrollToBottom()
    },

    addUserMessage(text) {
      this.messages.push({
        type: 'user',
        text: text,
        timestamp: new Date()
      })

      this.scrollToBottom()
    },

    async delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    async scrollToBottom() {
      await this.$nextTick()
      // 전체 페이지를 스크롤하여 채팅창 하단으로 이동
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    },

    async executeInvestment() {
      console.log('executeInvestment 호출됨')

      // 실제 투자 데이터 생성
      const investmentResults = this.generateInvestmentResults()
      console.log('생성된 투자 결과:', investmentResults)

      // 투자 데이터를 JSON 형태로 구성
      const investmentData = {
        totalAmount: parseInt(this.investmentAmount),
        distributionMethod: this.distributionMethod,
        investments: investmentResults.map(result => ({
          fundingDataIdx: result.id,
          title: result.title,
          amount: result.amount
        }))
      }
      console.log('저장할 투자 데이터:', investmentData)

      // Vuex store에 AI 투자 결과 저장
      this.$store.commit('funding/setAiInvestmentResult', investmentData)
      console.log('Vuex store에 AI 투자 결과 저장 완료')

      // 투자 페이지로 바로 이동
      this.$router.push({ name: 'invest' })
    },

    async restartConversation() {
      await this.addUserMessage('다시 시작하기')

      // 데이터 초기화
      this.messages = []
      this.userPreferences = {
        marketing: false,
        highSales: false,
        goodRepayment: false
      }
      this.selectedRecommendations = []
      this.investmentAmount = ''
      this.distributionMethod = ''

      await this.delay(500)

      // 대화 재시작
      await this.startConversation()
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-advisor-wrapper {
  max-width: 768px;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.chat-header {
  background-color: #1baaf1;
  color: white;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;

  .back-btn {
    color: white;
  }

  .header-title {
    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: bold;
    }

    .subtitle {
      margin: 4px 0 0 0;
      font-size: 12px;
      opacity: 0.8;
    }
  }
}

.chat-container {
  flex: 1;
  padding: 16px;
  padding-bottom: 32px;
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message {
  display: flex;

  &.ai {
    justify-content: flex-start;
  }

  &.user {
    justify-content: flex-end;
  }
}

.message-content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  max-width: 80%;
}

.ai-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #e3f2fd;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.message-bubble {
  background-color: white;
  border-radius: 16px;
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  .ai-name {
    font-size: 12px;
    color: #1baaf1;
    font-weight: bold;
    margin-bottom: 4px;
  }

  .message-text {
    font-size: 14px;
    line-height: 1.4;
    color: #333;
  }
}

.message.user .message-bubble {
  background-color: #1baaf1;
  color: white;

  .message-text {
    color: white;
  }
}

.message-options {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.option-item {
  background-color: #f0f8ff;
  border: 1px solid #1baaf1;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;

  &:hover {
    background-color: #e3f2fd;
  }

  &.disabled {
    background-color: #f5f5f5;
    border-color: #ccc;
    color: #999;
    cursor: not-allowed;

    &:hover {
      background-color: #f5f5f5;
    }
  }
}

.preference-options {
  margin-bottom: 12px;
}

.preference-item {
  margin-bottom: 8px;
  border: 1px solid #e0e0e0;
  background-color: white;

  &.selected {
    border-color: #1baaf1;
    background-color: #f0f8ff;
  }

  .option-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .checkbox {
    flex-shrink: 0;
  }

  .option-text {
    font-weight: 500;
  }
}

.complete-button-wrapper {
  border-top: 1px solid #e0e0e0;
  padding-top: 12px;
}

.complete-button {
  background-color: #1baaf1;
  color: white;
  font-weight: bold;
  text-align: center;
  border: none;

  &:hover {
    background-color: #0d8fd8;
  }

  &.disabled {
    background-color: #ccc;
    color: #999;
    cursor: not-allowed;

    &:hover {
      background-color: #ccc;
    }
  }
}

.recommendations {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.recommendation-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  background-color: #fafafa;
}

.rec-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  .rec-title {
    font-weight: bold;
    font-size: 16px;
  }
}

.rec-details {
  margin-left: 32px;

  p {
    margin: 4px 0;
    font-size: 13px;
  }

  .rec-loan {
    color: #666;
  }

  .rec-sales {
    color: #1baaf1;
    font-weight: bold;
  }

  .rec-features {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    .feature-tag {
      background-color: #e3f2fd;
      color: #1baaf1;
      padding: 2px 6px;
      border-radius: 4px;
      font-size: 11px;
    }
  }
}

.amount-input {
  margin-top: 12px;

  .confirm-btn {
    margin-top: 8px;
    width: 100%;
  }
}

.distribution-options {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.distribution-option {
  background-color: #f0f8ff;
  border: 1px solid #1baaf1;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e3f2fd;
  }
}

 .investment-results {
  margin-top: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.results-header {
  background-color: #f5f5f5;
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;

  h4 {
    margin: 0 0 4px 0;
    font-size: 16px;
    font-weight: bold;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #666;
  }
}

.results-list {
  background-color: white;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  .result-title {
    font-size: 14px;
    font-weight: 500;
  }

  .result-amount {
    font-size: 14px;
    font-weight: bold;
    color: #1baaf1;
  }
}
</style>
